require('./lbTimeSelect.scss');

const $inject = [];

const lbTimeSelect = {
  controller: 'lbTimeSelectCtrl as vm',
  template: require('./lbTimeSelect.html'),
  bindings: {
    date: '<',
    time: '=',
    timeFormat: '@',
    name: '@',
    required: '<',
    disabled: '<',
    sequentialTime: '@',
    beforeDate: '<',
    beforeTime: '<',
    anytime: '@',
  },
};

lbTimeSelect.$inject = $inject;

export default lbTimeSelect;



// WEBPACK FOOTER //
// ./src/components/lbTimeSelect/lbTimeSelect.js